var _a;
import { TransactionStatus } from '../const/transactionStatus';
var approvedDisputeTitleKey = 'transactionDisputeStatusTitle.disputeApproved';
var canceledDisputeTitleKey = 'transactionDisputeStatusTitle.disputeCanceled';
var cancelationProcessingDisputeTitleKey = 'transactionDisputeStatusTitle.cancelationProcessing';
var deniedDisputeTitleKey = 'transactionDisputeStatusTitle.disputeDenied';
var newDisputeTitleKey = 'transactionDisputeStatusTitle.new';
var temporaryCreditTitleKey = 'transactionDisputeStatusTitle.temporaryCredit';
var underReviewDisputeTitleKey = 'transactionDisputeStatusTitle.underReview';
var completedDisputeTitleKey = 'transactionDisputeStatusTitle.disputeCompleted';
var TransactionDisputeStatusTitleKeys = (_a = {},
    _a[TransactionStatus.SET_1] = newDisputeTitleKey,
    _a[TransactionStatus.SET_2] = underReviewDisputeTitleKey,
    _a[TransactionStatus.SET_3] = underReviewDisputeTitleKey,
    _a[TransactionStatus.SET_4] = underReviewDisputeTitleKey,
    _a[TransactionStatus.SET_5] = temporaryCreditTitleKey,
    _a[TransactionStatus.SET_6] = temporaryCreditTitleKey,
    _a[TransactionStatus.SET_7] = temporaryCreditTitleKey,
    _a[TransactionStatus.SET_8] = deniedDisputeTitleKey,
    _a[TransactionStatus.SET_9] = approvedDisputeTitleKey,
    _a[TransactionStatus.SET_10] = approvedDisputeTitleKey,
    _a[TransactionStatus.SET_11] = canceledDisputeTitleKey,
    _a[TransactionStatus.SET_12] = approvedDisputeTitleKey,
    _a[TransactionStatus.SET_13] = approvedDisputeTitleKey,
    _a[TransactionStatus.SET_14] = deniedDisputeTitleKey,
    _a[TransactionStatus.SET_15] = deniedDisputeTitleKey,
    _a[TransactionStatus.SET_16] = deniedDisputeTitleKey,
    _a[TransactionStatus.SET_17] = deniedDisputeTitleKey,
    _a[TransactionStatus.SET_18] = deniedDisputeTitleKey,
    _a[TransactionStatus.SET_19] = canceledDisputeTitleKey,
    _a[TransactionStatus.SET_20] = deniedDisputeTitleKey,
    _a[TransactionStatus.SET_21] = cancelationProcessingDisputeTitleKey,
    _a[TransactionStatus.SET_22] = underReviewDisputeTitleKey,
    _a[TransactionStatus.SET_23] = completedDisputeTitleKey,
    _a[TransactionStatus.SET_24] = completedDisputeTitleKey,
    _a[TransactionStatus.SET_25] = completedDisputeTitleKey,
    _a);
var getTranslationForTransactionDisputeTitle = function (status) {
    if (!TransactionDisputeStatusTitleKeys[status]) {
        return null;
    }
    return TransactionDisputeStatusTitleKeys[status];
};
export default getTranslationForTransactionDisputeTitle;
//# sourceMappingURL=getTranslationForTransactionDisputeTitle.js.map